
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.732 7.707v3.626a.66.66 0 01-.666.667H.932a.66.66 0 01-.666-.667V7.707a.66.66 0 01.666-.667.66.66 0 01.667.667v2.96h8.8v-2.96a.66.66 0 01.667-.667.66.66 0 01.666.667zm-6.213.826c.12.134.293.2.48.2a.655.655 0 00.48-.2l2.653-2.72a.672.672 0 00-.013-.946.672.672 0 00-.947.013L6.666 6.44V.667A.66.66 0 005.999 0a.66.66 0 00-.667.667V6.44l-1.52-1.547a.672.672 0 00-.946-.013.672.672 0 00-.014.947L5.52 8.533z","fill":"#748190"}})])
          )
        }
      }
    